// AgeVerifier.js
import { connect } from 'react-redux';
import AgeVerifier from '../component/AgeVerifier.jsx';
import removeModals from '../action/removeModals.js';
import submitAnonymousLogin from '../action/submitAnonymousLogin.js';
import login from '../action/login.js';
function mapDispatchToProps(dispatch) {
  return {
    closeModal: () =>
      dispatch(
        removeModals({ ids: ['AgeVerifierModal'], transitionStatus: 'closing' })
      ),
    login: () => dispatch(login({ isRequireDiamond: true })),
    submitAnonymousLogin: () => dispatch(submitAnonymousLogin()),
  };
}

export default connect(null, mapDispatchToProps)(AgeVerifier);
